import styled from 'styled-components'

import ButtonLink from '@/common/components/ButtonLink'

interface DotStatusProps {
  $isAvailable: boolean
}

export const DotStatus = styled.div<DotStatusProps>`
  background-color: ${({ theme, $isAvailable }) =>
    $isAvailable ? theme.colors.success : theme.colors.error};
  border-radius: 50%;
  width: 8px;
  height: 8px;
`

export const StyledButton = styled(ButtonLink).attrs({
  className: 'mx-auto',
  buttonClassName: 'text-12 text-nowrap px-8',
  variant: 'outline',
})`
  > button {
    height: 24px;
  }
`

export const MoreDetailWrapper = styled.div.attrs({
  className: 'py-16 pr-24',
})`
  padding-left: 97px;
`
